var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Hero',[_c('strong',[_vm._v("Вдохновленные вызовом")]),_vm._v(",\n    "),_c('br'),_vm._v("создаем  "),_c('em',[_vm._v("удивительные ")]),_c('em',[_vm._v(" продукты!")])]),_vm._v(" "),_c('ProjectsList')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c79a67d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Projects.vue
// module id = null
// module chunks = 